export const restaurantSubCategoryColumns = [
  {
    Header: "Dish name",
    accessor: "name",
  },
  {
    Header: "Description",
    accessor: "description",
  },
  {
    Header: "Price",
    accessor: "price",
  },
  // {
  //   Header: "Varients",
  //   accessor: "varients",
  // },
  {
    Header: "Action",
    accessor: "actions",
  },
];
